import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import type { Aufenthalt } from '@chancenwerk/enums/enums.js';
import { DateTime } from 'luxon';
import { DurchfuehrungsTag, Product } from './Product.js';

/**
 * @entity ProductLKK
 */
@Entity()
export class ProductLKK extends Product {
  public static override _class = 'ProductLKK';

  constructor(init: PartialEntityData<ProductLKK>) {
    super(init);
  }

  /**
   * If true the new LKK V2 courses are used.
   */
  @Field(() => Boolean)
  public useV2Courses: Maybe<boolean>;

  /**
   * Defines after which date the old LKK V1 courses are archived.
   * This means that up until this date the old data can still be accessed.
   */
  @Field(() => DateTime)
  public archiveV1After: Maybe<DateTime>;

  @Field(() => String)
  public lernkaskadeAufenthalt: Maybe<Aufenthalt>;

  @Field(() => String)
  public lernfoerderungAufenthalt: Maybe<Aufenthalt>;

  @Field(() => [DurchfuehrungsTag], { default: v => v ?? [] })
  public durchfuehrungsTage!: DurchfuehrungsTag[];

  @Field(() => Int)
  public ikProWoche: Maybe<number>;

  @Field(() => Int)
  public ikDauer: Maybe<number>;

  @Field(() => Int)
  public leFoeProWoche: Maybe<number>;

  @Field(() => Int)
  public leFoeDauer: Maybe<number>;

  @Field(() => Int)
  public uebungsLeiterProIK: Maybe<number>;

  @Field(() => Int)
  public OSProIK: Maybe<number>;

  @Field(() => Int)
  public uebungsLeiterProLernFoerderung: Maybe<number>;

  @Field(() => Int)
  public OSLernFoerderung: Maybe<number>;

  @Field(() => Int)
  public USLernFoerderung: Maybe<number>;

  initDefault() {
    this.leFoeProWoche = 2;
    this.leFoeDauer = 90;
    this.uebungsLeiterProLernFoerderung = 1;
    this.OSLernFoerderung = 6;
    this.USLernFoerderung = 12;
    this.ikProWoche = 1;
    this.ikDauer = 90;
    this.uebungsLeiterProIK = 1;
    this.OSProIK = 6;
  }
}
